module.exports = __webpack_public_path__ + "img/premium-icon.55ba2f04.svg";